<template>
  <div class="dynamic-house-page">
    <!-- Navbar Area -->
    <div class="navbar-area" :class="{ 'is-sticky': isSticky }">
      <div class="template-responsive-navbar">
          <div class="container">
              <div class="template-responsive-menubar">
                  <div class="logo">
                      <a href="/">
                        <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                      </a>
                  </div>
                  <div class="meanmenu-reveal" id="meanmenu-reveal" @click="toggleMobileMenu"><span></span></div>
              </div>
          </div>
          <!-- Mobile Menu -->
          <div class="mean-nav" :class="{ 'mean-show': isMobileMenuOpen }">
              <div class="mobile-menu-container">
                  <ul class="navbar-nav">
                    <li class="nav-item"><a href="/" class="nav-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'services')">{{ t.services }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'services' }">
                        <li class="nav-item"><router-link to="/dynamic" class="nav-link" @click.native="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</router-link></li>
                        <li class="nav-item"><a href="/static" class="nav-link" @click="handleMobileNavClick('/static')">{{ t.serviceStatic }}</a></li>
                      </ul>
                    </li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'blog')">{{ t.blog }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'blog' }">
                        <li class="nav-item"><a href="/faq" class="nav-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
                      </ul>
                    </li>
                    
                    <!-- Language Switcher -->
                    <li class="nav-item">
                      <a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'language')">
                        {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }} <i class="bx bx-plus dropdown-icon"></i>
                      </a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'language' }">
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')" style="padding: 10px 0 10px 20px;">English</button></li>
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')" style="padding: 10px 0 10px 20px;">中文</button></li>
                      </ul>
                    </li>
                  </ul>
                  
                  <div class="others-option d-flex flex-column mt-4">
                    <div class="item mb-3">
                      <a href="/login" class="default-btn">{{ t.signIn }}</a>
                    </div>
                    
                    <div class="item">
                      <a href="/register" class="default-btn">{{ t.signUp }}</a>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="template-navbar">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" href="/">
              <!-- <img :src="require('../assets/images/logo.png')" alt="logo"> -->
              <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
            </a>

            <button class="navbar-toggler" type="button" @click="isNavCollapsed = !isNavCollapsed" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mean-menu" :class="{ 'show': !isNavCollapsed }">
              <ul class="navbar-nav">
                <li class="nav-item"><a href="/" class="nav-link">{{ t.home }}</a></li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.services }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                    
                    <li class="nav-item"><a href="/static" class="nav-link">{{ t.serviceStatic }}</a></li>
                  </ul>
                </li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.blog }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><a href="/faq" class="nav-link">{{ t.faq }}</a></li>
                  </ul>
                </li>
                
                <!-- Language Switcher -->
                <li class="nav-item">
                  <a href="#" class="dropdown-toggle nav-link">
                    {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')">English</button></li>
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')">简体中文</button></li>
                  </ul>
                </li>
              </ul>

              <div class="others-option d-flex align-items-center">
                <div class="item">
                  <a href="/login" class="default-btn">{{ t.signIn }}</a>
                </div>

                <div class="item">
                  <a href="/register" class="default-btn">{{ t.signUp }}</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Banner Section -->
    <section class="dynamic-banner-section ptb-100">
      <div class="container">
        <div class="banner-grid">
          <div class="banner-item content-item">
            <div class="banner-content">
              <h1>{{ t.serviceDynamic }}</h1>
              <p>{{ t.dynamicDesc }}</p>
              <a href="#features" class="default-btn">{{ t.learnMore }}</a>
            </div>
          </div>
          <div class="banner-item image-item">
            <div class="banner-image">
              <img :src="require('../assets/images/features2.png')" alt="Dynamic Residence" class="img-fluid">
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Features Section -->
    <section id="features" class="features-section ptb-100 bg-light">
      <div class="container">
        <div class="section-title text-center">
          <h2>{{ t.featuresTitle }}</h2>
          <p>{{ t.featuresSubtitle }}</p>
        </div>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-globe'></i>
              </div>
              <h3>{{ t.globalCoverage }}</h3>
              <p>{{ t.globalCoverageDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-refresh'></i>
              </div>
              <h3>{{ t.autoRotation }}</h3>
              <p>{{ t.autoRotationDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-shield-alt'></i>
              </div>
              <h3>{{ t.highTrust }}</h3>
              <p>{{ t.highTrustDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-tachometer'></i>
              </div>
              <h3>{{ t.highSpeed }}</h3>
              <p>{{ t.highSpeedDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-network-chart'></i>
              </div>
              <h3>{{ t.multiProtocol }}</h3>
              <p>{{ t.multiProtocolDesc }}</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-box">
              <div class="icon">
                <i class='bx bx-headphone'></i>
              </div>
              <h3>{{ t.technicalSupport }}</h3>
              <p>{{ t.technicalSupportDesc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Features Section -->

    <!-- Benefits Section -->
    <section class="benefits-section ptb-100">
      <div class="container">
        <div class="benefits-grid">
          <div class="benefits-item image-item">
            <div class="benefits-image">
              <img :src="require('../assets/images/features1.png')" alt="Benefits" class="img-fluid">
            </div>
          </div>
          <div class="benefits-item content-item">
            <div class="benefits-content">
              <h2>{{ t.benefitsTitle }}</h2>
              <ul class="benefits-list">
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit1 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit2 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit3 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit4 }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.benefit5 }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Benefits Section -->

    <!-- Pricing Section -->
    <section class="pricing-section ptb-100 bg-light">
      <div class="container">
        <div class="section-title text-center">
          <h2>{{ t.pricingTitle }}</h2>
          <p>{{ t.pricingSubtitle }}</p>
        </div>
        <div class="pricing-grid">
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.basicPlan }}</h3>
                <span>1GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $6
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.standardPlan }}</h3>
                <span>10GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $60
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.advancedPlan }}</h3>
                <span>50GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $300
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
          <div class="pricing-item">
            <div class="pricing-plan">
              <div class="title">
                <div class="icon">
                  <i class='bx bx-data'></i>
                </div>
                <h3>{{ t.enterprisePlan }}</h3>
                <span>100GB</span>
              </div>
              <ul class="features">
                <li><i class='bx bxs-badge-check'></i>{{ t.premiumIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.rotatingIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.highTrustIPs }}</li>
                <li><i class='bx bxs-badge-check'></i>{{ t.unlimitedThreads }}</li>
              </ul>
              <div class="pricing-footer">
                <div class="price">
                  $600
                  <span>/month</span>
                </div>
                <a href="/login" class="default-btn">{{ t.getNow }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Pricing Section -->

    <!-- Footer Section -->
    <footer class="footer-section pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.contactInfo }}</h3>
                        <ul class="footer-contact-info">
                            <!-- <li>Fish St Hill, Bridge, London EC3R 8AH, UK</li> -->
                            <li><a href="javascript:void(0);">super@proxylink.net</a></li>
                            <!-- <li><a href="tel:++254 25413 521">+254 25413 521</a></li>
                            <li><a href="tel:+254 25413 521">+254 25413 521</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget pl-4">
                        <h3>{{ t.usefulLinks }}</h3>
                        <ul class="links-list">
                            <!-- <li><a href="#">About Us</a></li> -->
                            <!-- <li><a href="#">Features</a></li> -->
                            <li><a href="/faq">{{ t.faq }}</a></li>
                            <!-- <li><a href="#">Blog</a></li> -->
                            <!-- <li><a href="#">Contact</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.support }}</h3>
                        <ul class="links-list">
                            <li><router-link to="/privacy">{{ t.privacyPolicy }}</router-link></li>
                            <li><router-link to="/service-policy">{{ t.termsOfService }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <a href="/" class="logo d-inline-block">
                            <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                        </a>
                        <p>{{ t.welcomeMessage }}</p>
                        <ul class="social-links">
                            <li><a href="javascript:void(0);"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="container">
                <p>{{ t.copyright }}</p>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->

    <div class="go-top" :class="{ 'active': showGoTop }" @click="scrollToTop"><i class='bx bx-up-arrow-alt'></i></div>
  </div>
</template>

<script>
export default {
  name: 'DynamicHouse',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      showGoTop: false,
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: null,
      // 页面文本国际化配置
      i18n: {
        en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            blog: 'Tutorial Center',
            faq: 'FAQs',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            learnMore: 'Buy Now',
            dynamicDesc: 'High-quality dynamic residential IP proxy services to help you easily access global network resources while protecting your privacy and security.',
            featuresTitle: 'Key Features',
            featuresSubtitle: 'Discover the powerful features of our dynamic residential proxy services',
            globalCoverage: 'Global IP Coverage',
            globalCoverageDesc: 'Access to millions of residential IPs from over 170+ countries and regions',
            autoRotation: 'Automatic IP Rotation',
            autoRotationDesc: 'Automatically rotate IPs at intervals or on each request',
            highTrust: 'High Trust IPs',
            highTrustDesc: 'Avoid detection with IPs that have high trust scores',
            highSpeed: 'High Speed & Low Latency',
            highSpeedDesc: 'Fast and stable connections for optimal performance',
            multiProtocol: 'Multi-Protocol Support',
            multiProtocolDesc: 'Supports HTTP, HTTPS, and SOCKS5 protocols',
            technicalSupport: '24/7 Technical Support',
            technicalSupportDesc: 'Professional support team available around the clock',
            benefitsTitle: 'Why Choose Our Dynamic Residential Proxies?',
            benefit1: 'Access geo-restricted content',
            benefit2: 'Bypass IP bans and restrictions',
            benefit3: 'Protect your online privacy',
            benefit4: 'Ideal for web scraping and data mining',
            benefit5: 'Suitable for ad verification and market research',
            pricingTitle: 'Flexible Pricing Plans',
            pricingSubtitle: 'Choose the perfect plan for your needs',
            basicPlan: 'BASIC',
            standardPlan: 'STANDARD',
            advancedPlan: 'ADVANCED',
            enterprisePlan: 'ENTERPRISE',
            premiumIPs: 'Premium Residential IPs',
            rotatingIPs: 'Rotating IPs',
            rotatingSticky: 'Rotating & Sticky IPs',
            highTrustIPs: 'High Trust IPs',
            unlimitedThreads: 'Unlimited Threads',
            getNow: 'Get Now',
            footerDesc: 'Your trusted partner for high-quality proxy services with global coverage and exceptional performance.',
            quickLinks: 'Quick Links',
            residentialProxies: 'Residential Proxies',
            mobileProxies: 'Mobile Proxies',
            datacenterProxies: 'Datacenter Proxies',
            rotatingProxies: 'Rotating Proxies',
            contactUs: 'Contact Us',
            address: '123 Proxy Street, Suite 456, Proxy City, PC 12345',
            phone: '+1 (123) 456-7890',
            email: 'info@proxylink.com',
            copyright: 'ProxyLink. All rights reserved.',
            privacyPolicy: 'Privacy Policy',
            termsOfService: 'Terms of Service',
            contactInfo: 'Contact Info',
            usefulLinks: 'Useful Links',
            support: 'Support',
            welcomeMessage: 'Welcome to try our products!'
          },
          zh: {
            home: '首页',
            services: '套餐',
            serviceDynamic: '动态住宅',
            serviceStatic: '静态住宅',
            blog: '教程中心',
            faq: '常见问题',
            signIn: '登录',
            signUp: '注册',
            learnMore: '立即购买',
            dynamicDesc: '高质量的动态住宅IP代理服务，帮助您轻松访问全球网络资源，同时保护您的隐私和安全。',
            featuresTitle: '核心功能',
            featuresSubtitle: '探索我们动态住宅代理服务的强大功能',
            globalCoverage: '全球IP覆盖',
            globalCoverageDesc: '访问来自170多个国家和地区的数百万住宅IP',
            autoRotation: '自动IP轮换',
            autoRotationDesc: '按时间间隔或每次请求自动轮换IP',
            highTrust: '高信任IP',
            highTrustDesc: '使用具有高信任评分的IP避免检测',
            highSpeed: '高速低延迟',
            highSpeedDesc: '快速稳定的连接，提供最佳性能',
            multiProtocol: '多协议支持',
            multiProtocolDesc: '支持HTTP、HTTPS和SOCKS5协议',
            technicalSupport: '24/7技术支持',
            technicalSupportDesc: '专业支持团队全天候为您服务',
            benefitsTitle: '为什么选择我们的动态住宅代理？',
            benefit1: '访问地理限制内容',
            benefit2: '绕过IP禁令和限制',
            benefit3: '保护您的在线隐私',
            benefit4: '理想的网页抓取和数据挖掘工具',
            benefit5: '适合广告验证和市场研究',
            pricingTitle: '灵活的定价计划',
            pricingSubtitle: '选择适合您需求的完美计划',
            basicPlan: '基础版',
            standardPlan: '标准版',
            advancedPlan: '高级版',
            enterprisePlan: '企业版',
            premiumIPs: '优质住宅IP',
            rotatingIPs: '动态IP',
            rotatingSticky: '动态&静态IP',
            highTrustIPs: '高信任IP',
            unlimitedThreads: '无限线程',
            getNow: '立即购买',
            footerDesc: '您值得信赖的高质量代理服务合作伙伴，提供全球覆盖和卓越性能。',
            quickLinks: '快速链接',
            residentialProxies: '住宅代理',
            mobileProxies: '移动代理',
            datacenterProxies: '数据中心代理',
            rotatingProxies: '动态代理',
            contactUs: '联系我们',
            address: '代理街123号，456室，代理城，PC 12345',
            phone: '+1 (123) 456-7890',
            email: 'info@proxylink.com',
            copyright: 'ProxyLink。保留所有权利。',
            privacyPolicy: '隐私政策',
            termsOfService: '服务条款',
            contactInfo: '联系信息',
            usefulLinks: '有用链接',
            support: '支持',
            welcomeMessage: '欢迎试用我们的产品！'
          }
      }
    }
  },
  computed: {
    // 获取当前语言的文本
    t() {
      const lang = this.languageState.currentLanguage;
      return this.i18n[lang] || this.i18n.en;
    }
  },
  methods: {
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = null;
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航链接点击
    handleMobileNavClick(targetRoute) {
      // 检查当前路由是否与目标路由相同
      if (this.$route.path === targetRoute) {
        // 关闭移动端菜单
        this.isMobileMenuOpen = false;
        // 重置下拉菜单
        this.activeDropdown = null;
        // 切换按钮样式
        const menuButton = document.getElementById('meanmenu-reveal');
        if (menuButton) {
          menuButton.classList.remove('active');
        }
      }
    },
    // 切换下拉菜单
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    // 监听滚动事件
    handleScroll() {
      const scrollPosition = window.pageYOffset;
      
      // 显示/隐藏回到顶部按钮
      this.showGoTop = scrollPosition > 300;
      
      // 粘性导航栏
      this.isSticky = scrollPosition > 100;
    },
    // 滚动到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

/* Default Button Styles */
.default-btn {
  display: inline-block;
  border: none;
  box-shadow: 0;
  transition: var(--transition);
  text-decoration: none;
  background-color: var(--mainColor);
  color: var(--whiteColor);
  padding: 12px 35px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
}

.default-btn:hover {
  color: var(--whiteColor);
}

.default-btn:hover::before {
  opacity: 0;
  visibility: hidden;
}

.default-btn::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  opacity: 1;
  visibility: visible;
  border-radius: 5px;
  transition: var(--transition);
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
}

/* Container Styles */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Padding Styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-100 {
  padding-bottom: 100px;
}

.pb-70 {
  padding-bottom: 70px;
}

/* Background Styles */
.bg-light {
  background-color: #f8f9fa;
}

/* Section Title Styles */
.section-title {
  text-align: center;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 25px;
  margin-bottom: 12px;
}

.section-title p {
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}
/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
</style>

<style scoped>
.dynamic-banner-section {
  background-color: #F7FAFD;
}

/* Banner Grid Styles */
.banner-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.banner-item {
  flex: 0 0 calc(50% - 20px);
  max-width: calc(50% - 20px);
}

/* Features Grid Styles */
.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.feature-item {
  flex: 0 0 calc(33.333% - 20px);
  max-width: calc(33.333% - 20px);
}

/* Benefits Grid Styles */
.benefits-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.benefits-item {
  flex: 0 0 calc(50% - 20px);
  max-width: calc(50% - 20px);
}

/* Banner Content Styles */
.banner-content h1 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
}

.banner-content p {
  font-size: 1.125rem;
  margin-bottom: 30px;
  color: #666;
  line-height: 1.6;
}

/* Image Styles */
.img-fluid {
  max-width: 100%;
  height: auto;
}

/* Responsive Design for Grids */
@media (max-width: 992px) {
  .banner-item,
  .benefits-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .feature-item {
    flex: 0 0 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .feature-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.section-title {
  margin-bottom: 50px;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
}

.section-title p {
  font-size: 1.125rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
}

.feature-box {
  background: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 30px;
}

.feature-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.feature-box .icon {
  width: 60px;
  height: 60px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: #fff;
  font-size: 1.5rem;
}

.feature-box h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #2c3e50;
}

.feature-box p {
  color: #666;
  line-height: 1.6;
}

.benefits-content h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #2c3e50;
}

.benefits-list {
  list-style: none;
  padding: 0;
}

.benefits-list li {
  padding: 10px 0;
  color: #666;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
}

.benefits-list li i {
  color: #007bff;
  margin-right: 15px;
  font-size: 1.25rem;
}

.pricing-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.pricing-item {
  flex: 0 0 calc(25% - 20px);
  max-width: calc(25% - 20px);
  margin-top: 0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .pricing-item {
    flex: 0 0 calc(33.333% - 20px);
    max-width: calc(33.333% - 20px);
  }
}

@media (max-width: 992px) {
  .pricing-item {
    flex: 0 0 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 768px) {
  .pricing-item {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.pricing-plan {
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;
  display: block;
  opacity: 1;
  visibility: visible;
}



.pricing-plan .title {
  margin-bottom: 30px;
  text-align: center;
}

.pricing-plan .icon {
  width: 60px;
  height: 60px;
  background: #007bff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 0 auto 20px; */
  color: #fff;
  font-size: 1.5rem;
}

.pricing-plan h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  color: #2c3e50;
  text-align: center;
}

.pricing-plan span {
  color: #666;
  font-size: 1rem;
  text-align: center;
}

.pricing-plan .features {
  list-style: none;
  padding: 0;
  margin-bottom: 30px;
}

.pricing-plan .features li {
  padding: 10px 0;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pricing-plan .features li i {
  color: #28a745;
  margin-right: 10px;
}

.pricing-plan .pricing-footer {
  text-align: center;
}

.pricing-plan .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: #007bff;
  margin-bottom: 20px;
  text-align: center;
}

.pricing-plan .price span {
  font-size: 1rem;
  color: #666;
  font-weight: normal;
  text-align: center;
}

.footer-section {
  background: #3B566E;
  color: #fff;
  padding: 100px 0 0;
}

.footer-widget {
  margin-bottom: 30px;
}

.footer-widget h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
}

.footer-widget.pl-4 {
  padding-left: 0;
}

.footer-contact-info {
  list-style: none;
  padding: 0;
}

.footer-contact-info li {
  margin-bottom: 15px;
  color: #ddd;
  line-height: 1.6;
}

.footer-contact-info a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-contact-info a:hover {
  color: #007bff;
}

.links-list {
  list-style: none;
  padding: 0;
}

.links-list li {
  margin-bottom: 15px;
}

.links-list a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px;
  display: block;
}

.links-list a:hover {
  color: #007bff;
  padding-left: 5px;
}

.logo {
  display: inline-block;
  /* margin-bottom: 20px; */
}

.logo a {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
}

.logo-text {
  color: #fff;
}

.social-links {
  list-style: none;
  padding: 0;
  display: flex;
  margin-top: 20px;
}

.social-links li {
  margin-right: 15px;
}

.social-links a {
  color: #fff;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-links a:hover {
  background: #007bff;
  transform: translateY(-3px);
}

.footer-widget p {
  color: #ddd;
  line-height: 1.6;
  margin-bottom: 20px;
}

.copyright-area {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  margin-top: 30px;
}

.copyright-area p {
  color: #ddd;
  margin: 0;
  text-align: center;
}

.go-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  background: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
}

.go-top:hover {
  background: #0056b3;
  transform: translateY(-3px);
}

</style>